import classNames from 'classnames';
import React from 'react';
import { AspectRatioWrapper, PrimaryButton, ResponsiveImage } from '../../../components';
import { lazyLoadWithDimensions } from '../../../util/uiHelpers';
import { FormattedMessage } from 'react-intl';

import css from './ContactArtist.module.css';

const LazyImage = lazyLoadWithDimensions(ResponsiveImage, { loadAfterInitialRendering: 3000 });

const ContactArtist = props => {
  const { className, listing, contactArtistDisabled, onCtaClicked } = props;
  const { title = '' } = listing?.attributes || {};
  const coverImage = listing?.images?.[0];

  if (!coverImage) return null;

  const variants = coverImage.attributes.variants;
  const variantsArr = Object.keys(variants);

  return (
    <div className={classNames(css.root, className)}>
      <AspectRatioWrapper className={css.aspectRatioWrapper} width={1} height={1}>
        <LazyImage
          rootClassName={css.rootForImage}
          alt={title}
          image={coverImage}
          variants={variantsArr}
        />
      </AspectRatioWrapper>
      <PrimaryButton
        className={css.contactBtn}
        rootClassName={css.contact}
        onClick={onCtaClicked}
        enforcePagePreloadFor="SignupPage"
        disabled={contactArtistDisabled}
      >
        <FormattedMessage id="ContactArtist.cta" />
      </PrimaryButton>
      <p className={css.desc}>
        {!contactArtistDisabled ? (
          <FormattedMessage id="ContactArtist.desc" />
        ) : (
          <FormattedMessage id="ContactArtitst.disabledText" />
        )}
      </p>
    </div>
  );
};

export default ContactArtist;
